import { Box, Checkbox, CheckboxProps, Radio, RadioProps, Text } from '@cmpsr/components';
import { FC } from 'react';
import { type QuestionOptionProps } from './types';

export const QuestionOption: FC<QuestionOptionProps> = ({
  componentType,
  componentProps,
  label,
  description,
  ...props
}) => {
  const elementContent = (
    <>
      <Text variant="text-body-regular" color="text-primary" mr="spacer-4">
        {label}
      </Text>
      {description ?? (
        <Text variant="text-body-meta-regular" color="text-secondary" mr="spacer-4">
          {description}
        </Text>
      )}
    </>
  );

  const commonProps = {
    display: 'flex',
    flexDirection: 'row-reverse',
    variant: 'outline',
    size: 'l',
    m: 'auto',
    justifyContent: 'space-between',
    py: 'spacer-3',
    px: 'spacer-4',
    alignItems: 'center',
  };

  return (
    <Box
      {...props}
      mb="spacer-4"
      mx="auto"
      sx={{
        '& > label': {
          background: 'background-action-default',
          border: '1px solid var(--chakra-colors-ui-element-outline-default)',
          borderRadius: 'radii-4',
        },
        '& > label[data-checked]': {
          borderColor: 'secondary-default',
          boxShadow:
            'var(--chakra-shadows-elevation-interactive), inset 0px 0px 0px 1px var(--chakra-colors-secondary-default)',
        },
      }}
    >
      {componentType === 'checkbox' && (
        <Checkbox
          {...(commonProps as CheckboxProps)}
          {...(componentProps as CheckboxProps)}
          sx={{ span: { marginTop: '0' } }}
        >
          {elementContent}
        </Checkbox>
      )}
      {componentType === 'radio' && (
        <Radio {...(commonProps as RadioProps)} {...(componentProps as RadioProps)} gap="spacer-4">
          {elementContent}
        </Radio>
      )}
    </Box>
  );
};
